"use client"

import { useState, useEffect } from "react"
import { Menu, X, Zap } from "lucide-react"

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const navLinks = [
    { label: "Features", href: "#features" },
    { label: "Pricing", href: "#pricing" },
    { label: "FAQ", href: "#faq" },
  ]

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#09090f]/90 backdrop-blur-md border-b border-white/[0.06]"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        {/* Logo */}
        <a href="#" className="flex items-center gap-2 group">
          <div className="w-8 h-8 rounded-lg bg-[#00e5ff] flex items-center justify-center glow-cyan-sm">
            <Zap className="w-4 h-4 text-[#09090f]" strokeWidth={2.5} />
          </div>
          <span
            className="text-xl font-bold text-[#f8fafc] tracking-tight"
            style={{ fontFamily: "var(--font-space-grotesk, sans-serif)" }}
          >
            AutoP2P
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="text-sm font-medium text-[#8892a4] hover:text-[#f8fafc] transition-colors duration-200"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#pricing"
            className="inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-[#00e5ff] text-[#09090f] text-sm font-semibold hover:bg-[#33eaff] transition-all duration-200 glow-cyan-sm hover:glow-cyan"
          >
            Book a Demo
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          className="md:hidden p-2 rounded-lg text-[#8892a4] hover:text-[#f8fafc] hover:bg-white/[0.06] transition-colors"
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </nav>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-[#0f0f1a]/95 backdrop-blur-md border-b border-white/[0.06] px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setIsOpen(false)}
              className="text-sm font-medium text-[#8892a4] hover:text-[#f8fafc] transition-colors py-1"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#pricing"
            onClick={() => setIsOpen(false)}
            className="inline-flex items-center justify-center px-5 py-2.5 rounded-lg bg-[#00e5ff] text-[#09090f] text-sm font-semibold"
          >
            Book a Demo
          </a>
        </div>
      )}
    </header>
  )
}
